module.exports = {
    title: "Machines",
    crud: {
        create: "Create Machine",
        machine_resource: "Machine Resource",
        edit: "Edit Machine",
        view_response: "Response",
        view_report: "Report",
        view_media: 'Media',
        detail: 'Details',
    },
    table: {
        name: "Name",
        machineType: "Machine Type",
        visibility: "Visibility",
        information: "Information",
        description: "Description",
        budget: 'Budget',
        isActive: 'Active',
        remoteWork: 'Remote Work',
        status: 'Status',
    },
    form: {
        name: "Name",
        manufacturer: "Manufacturer",
        modelNumber: "Model Number",
        machineCondition: "Machine Condition",
        yearOfManufacture: "Year Of Manufacture",
        fuelRequirement: "Fuel Requirement",
        fuelType: "Fuel Type",
        noOfPersonMontoring: "No Of Person Montoring",
        quantity: "Quantity",
        weight: "Weight",
        length: "Length",
        width: "Width",
        height: "Height",
        usageHours: "Usage Hours",
        warrantyStatus: "Warranty Status",
        transactionType: "Transaction Type",
        workStartDate: "Work Start Date",
        workEndDate: "Work End Date",
        rentalPricePerHour: "Rental Price Per Hour",
        rentalDeposit: "Rental Deposit",
        salePrice: "Sale Price",
        acquisitionDate: "Acquisition Date",
        minPrice: "Min Price",
        maxPrice: "Max Price",
        category: "Category",
        machineIndustry: "Machine Industry",
        description: "Description"
    },

    filter: {
        startDate: 'Start Date',
        endDate: 'End Date',
        industry: 'Industry',
        subIndustry: 'Services',
        resourceType: 'Resource Type',
        currency: 'Currency  Type',
        duration: 'Duration',
        priority: 'Priority',
        budget: 'Budget',
        isActive: 'Active',
        workType: 'Work type',
        user: 'User',
        profileVerified: 'Profile Verified',
        remoteWork: 'Remote Work',
        skills: 'Skills',
        visibility: "Visibility",
        min_budget: 'Minimum Budget',
        max_budget: 'Maximum Budget',
    },

    validation: {
        required: {
            name: 'Name is required',
            skills: 'Skill is required',
            description: 'Description is required',
            MachineType: 'machine type is required',
            industry: 'Industry is required',
            subIndustry: 'Services is required',
            budget: 'Budget is required',
            resourceType: 'Resource type is required',
            workType: 'Work type is required',
            priority: 'Priority  is required',
            currency: 'Currency type is required',
            duration: 'Duration is required',
            user: 'User is required',
            status: 'Status is required',
        },
        minLength: {
            name: 'Name must have at least',
            type: 'Type must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
